module.exports = __webpack_public_path__ + "img/xiazai3.6a582b4f.png";